import { useTranslation } from "react-i18next";

import { ScreenState } from "@/widgets/screen-state";

/**
 * Экран блокировки (403 `FORBIDDEN`). Figma: `State · Trading Access Error`
 * (28:18) — тот же блок, что у пустых состояний, в тональности loss.
 *
 * Действия здесь нет намеренно: разблокировать себя пользователь не может,
 * а кнопка «Повторить» создавала бы ложное ожидание.
 */
export function BlockedPage() {
  const { t } = useTranslation();

  return (
    <ScreenState tone="loss" icon="warningFill" title={t("states.blocked.title")} body={t("states.blocked.body")} />
  );
}
